import { t } from '../i18n/index.js';
import { PASSWORD_MAX, PASSWORD_MIN, passwordProblem } from '../../shared/registration.js';

/**
 * New password + repeat, with the password rules ticked off while typing
 * (at least 8 characters and a special character, decision 2026-09-28).
 */
export function NewPasswordFields(props: {
  value: string;
  repeat: string;
  onValue: (v: string) => void;
  onRepeat: (v: string) => void;
  label: string;
  repeatLabel: string;
  autofocus?: boolean;
}) {
  const longEnough = [...props.value].length >= PASSWORD_MIN;
  const hasSpecial = /[^\p{L}\p{N}\s]/u.test(props.value);
  return (
    <>
      <label>
        {props.label}
        <input
          type="password"
          value={props.value}
          onInput={(e) => props.onValue(e.currentTarget.value)}
          autocomplete="new-password"
          maxLength={PASSWORD_MAX}
          required
          autofocus={props.autofocus}
        />
      </label>
      <ul class="password-rules" aria-live="polite">
        <li class={longEnough ? 'ok' : ''}>{t.password.ruleLength}</li>
        <li class={hasSpecial ? 'ok' : ''}>{t.password.ruleSpecial}</li>
      </ul>
      <label>
        {props.repeatLabel}
        <input
          type="password"
          value={props.repeat}
          onInput={(e) => props.onRepeat(e.currentTarget.value)}
          autocomplete="new-password"
          maxLength={PASSWORD_MAX}
          required
        />
      </label>
    </>
  );
}

/** Client-side check before sending: an error text or null. */
export function newPasswordError(value: string, repeat: string, mismatchText: string): string | null {
  if (passwordProblem(value)) return t.errors.weak_password;
  if (value !== repeat) return mismatchText;
  return null;
}
